import {CheckIcon, ExclamationIcon, XIcon} from '@primer/octicons-react'
import type {StackSectionStatusType} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import CircleOcticon from '@github-ui/circle-octicon'
import {HEADER_ICON_SIZE} from '../../../constants'

export function StatusIcon({status}: {status: StackSectionStatusType}) {
  let className
  let Icon
  switch (status) {
    case 'BLOCKED':
    case 'FAILED':
      Icon = XIcon
      className = 'bgColor-danger-emphasis fgColor-onEmphasis'
      break
    case 'PASSED':
      Icon = CheckIcon
      className = 'bgColor-success-emphasis fgColor-onEmphasis'
      break
    case 'PENDING':
      Icon = ExclamationIcon
      className = 'bgColor-attention-emphasis fgColor-onEmphasis'
      break
    case 'UNKNOWN':
    default:
      Icon = ExclamationIcon
      className = 'bgColor-muted fgColor-onEmphasis'
      break
  }

  return <CircleOcticon className={className} size={HEADER_ICON_SIZE} icon={() => <Icon size={16} />} />
}

export function StackStatusIcon({
  status,
  isFirstUnmergedPRInStack,
}: {
  status: StackSectionStatusType
  isFirstUnmergedPRInStack: boolean
}) {
  let className
  let Icon
  switch (status) {
    case 'BLOCKED':
    case 'FAILED':
      //TODO: when StackRemoveIcon is available, replace the first XIcon with it
      Icon = isFirstUnmergedPRInStack ? XIcon : XIcon
      className = 'bgColor-danger-emphasis fgColor-onEmphasis'
      break
    case 'PASSED':
      //TODO: when StackCheckIcon is available, replace the first CheckIcon with it
      Icon = isFirstUnmergedPRInStack ? CheckIcon : CheckIcon
      className = 'bgColor-success-emphasis fgColor-onEmphasis'
      break
    case 'PENDING':
      Icon = ExclamationIcon
      className = 'bgColor-attention-emphasis fgColor-onEmphasis'
      break
    default:
      Icon = ExclamationIcon
      className = 'bgColor-muted fgColor-onEmphasis'
      break
  }

  return <CircleOcticon className={className} size={HEADER_ICON_SIZE} icon={() => <Icon size={16} />} />
}
